import { createAppKit } from "@reown/appkit/react";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { defineChain } from "@reown/appkit/networks";
import { cookieStorage, createStorage } from "wagmi";
import { ENV } from "./constants";

// Define HyperEVM Testnet
export const hyperEvmTestnet = defineChain({
  id: 998,
  caipNetworkId: "eip155:998",
  chainNamespace: "eip155",
  name: "HyperEVM Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "HYPE",
    symbol: "HYPE",
  },
  blockExplorers: {
    default: {
      name: "HyperEVM Testnet Explorer",
      url: "https://testnet.purrsec.com",
    },
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.hyperliquid-testnet.xyz/evm"],
    },
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11" as `0x${string}`,
      blockCreated: 0,
    },
  },
  testnet: true,
});

export const hyperEvm = defineChain({
  id: 999,
  caipNetworkId: "eip155:999",
  chainNamespace: "eip155",
  name: "HyperEVM",
  nativeCurrency: { name: "HYPE", symbol: "HYPE", decimals: 18 },
  blockExplorers: {
    default: {
      name: "HyperEVMScan",
      url: "https://hyperevmscan.io",
    },
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.hyperliquid.xyz/evm"],
    },
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11" as `0x${string}`,
      blockCreated: 13051,
    },
  },
  testnet: false,
});

// Get projectId from https://cloud.reown.com
const projectId = import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID || "";

const metadata = {
  name: "Helm",
  description: "Helm - Automated Market Maker for Hyperliquid",
  url: window.location.origin,
  icons: [`${window.location.origin}/logo.svg`],
};

export const network = (function () {
  if (ENV == "testnet") {
    return hyperEvmTestnet;
  }
  // Both mainnet and private-mainnet use hyperEvm (chain ID 999)
  return hyperEvm;
})();

export const wagmiAdapter = new WagmiAdapter({
  storage: createStorage({
    storage: cookieStorage,
  }),
  ssr: false,
  projectId,
  networks: [network],
});

export const config = wagmiAdapter.wagmiConfig;

// Create modal
createAppKit({
  adapters: [wagmiAdapter],
  projectId,
  networks: [network],
  defaultNetwork: network,
  metadata,
  termsConditionsUrl: `${window.location.origin}/terms`,
  privacyPolicyUrl: `${window.location.origin}/privacy`,
  features: {
    analytics: false,
    email: false,
    socials: false,
    legalCheckbox: true,
  },
  themeMode: "dark",
  themeVariables: {
    "--w3m-color-mix": "#061611",
    "--w3m-color-mix-strength": 40,
    "--w3m-font-family":
      'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    "--w3m-z-index": 9999,
    "--w3m-accent": "#4dbfae",
  },
});
